import { Button } from "components/atoms/Button";
import { BuildingIcon, ToolIcon, WarningCountIcon } from "components/atoms/Icon";
import { usePermissions } from "hooks/usePermissions";
import { useLocation } from "react-router-dom";
import useBuildingSidebarState from "recoilStore/CustomPlan/useBuildingSidebarState";
import { Tab, UserPermissions } from "utils/enums";
import PlanDropDown from "../DecarbonizationReport/PlanDropDown";
import DeleteBuilding from "./DeleteBuilding";
import PlanComparator from "./PlanComparator/PlanComparator";

interface BuildingHeaderActionsProps {
    buildingModel: Building;
    selectedBMCRP: BuildingModelCarbonReductionPlan | null;
}

function BuildingHeaderActions({ buildingModel, selectedBMCRP }: BuildingHeaderActionsProps) {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const currentActiveTab = pathParts[6] as Tab;
    const { hasPermission } = usePermissions();

    const { state: sidebarState, setState: setSidebarState } = useBuildingSidebarState();

    return (
        <div className="baseline-building-report-header__menu-items">
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    width: "max-content",
                }}
            >
                {currentActiveTab !== Tab.OutcomesV1 && (
                    <div
                        style={{
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        <PlanDropDown buildingModel={buildingModel} selectedBMCRP={selectedBMCRP} />
                    </div>
                )}
                {currentActiveTab === Tab.OutcomesV1 && (
                    <div
                        style={{
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        <PlanComparator />
                    </div>
                )}
                {hasPermission(UserPermissions.UseInternalTools) && (
                    <Button
                        type="secondary"
                        onClick={() => {
                            window.location.href = `/sandbox/building/${buildingModel.buildingModelUid}${window.location.search}`;
                        }}
                        icon={<ToolIcon color="black" />}
                        id="sandbox-button"
                    >
                        Sandbox
                    </Button>
                )}
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                    }}
                >
                    <Button
                        type="secondary"
                        onClick={() =>
                            setSidebarState({
                                ...sidebarState,
                                isSidebarOpen: true,
                            })
                        }
                        icon={<BuildingIcon />}
                        id="building-profile-button"
                    >
                        Profile
                    </Button>
                    {!selectedBMCRP && (
                        <WarningCountIcon
                            style={{
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                            }}
                        />
                    )}
                </div>
            </div>
            <DeleteBuilding
                buildingModelUid={buildingModel.buildingModelUid}
                buildingName={buildingModel.buildingName}
            />
        </div>
    );
}

export default BuildingHeaderActions;
